"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _SuccessHeaderModule = _interopRequireDefault(require("./SuccessHeader.module.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Modules
// Styles
var SuccessHeader = function SuccessHeader(props) {
  var _props$total = props.total,
      total = _props$total === void 0 ? '' : _props$total,
      _props$heading = props.heading,
      heading = _props$heading === void 0 ? '' : _props$heading,
      children = props.children;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _SuccessHeaderModule.default.header
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: _SuccessHeaderModule.default.icon
  }, /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: 'check-circle'
  })), total ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("h3", null, "Payment successful"), /*#__PURE__*/_react.default.createElement("p", null, "Your invoice for $".concat(total, " has been paid."))) : /*#__PURE__*/_react.default.createElement("h3", null, heading ? heading : 'Payment complete'), children);
};

var _default = SuccessHeader;
exports.default = _default;